// extracted by mini-css-extract-plugin
export default {"value":"Balance_value_eoxos"};